import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form } from "reactstrap";

import { Col, Container, Row } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
// import Breadcrumbs from "components/Common/Breadcrumb2";



import Welcomegreet from "components/Welcomegreet";
import Welcomecards from "components/Welcomecards";

// Store
import {
  getGraphDataRequest,
  // getStakeStats,
  getTransactionRequest,
} from "store/actions";
import LatestCustomers from "./LatestCustomers";
import { GraphWidget } from "components/GraphWidget";

export const getMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString("en-US", { month: "long" });
};

export const makeGraphDataFormat = (arr) => {
  const newObj = {};
  arr?.forEach((item) => {
    const month = getMonthName(item?._id?.month);
    const total = item?.total;
    if (!newObj.hasOwnProperty(month)) {
      newObj[month] = total;
    }
  });
  return newObj;
};

export const userDataGraph = [
  {
    name: "January",
    Revenue: 0,
  },
  {
    name: "February",
    Revenue: 0,
  },
  {
    name: "March",
    Revenue: 0,
  },
  {
    name: "April",
    Revenue: 0,
  },
  {
    name: "May",
    Revenue: 0,
  },
  {
    name: "June",
    Revenue: 0,
  },
  {
    name: "July",
    Revenue: 0,
  },
  {
    name: "August",
    Revenue: 0,
  },
  {
    name: "September",
    Revenue: 0,
  },
  {
    name: "October",
    Revenue: 0,
  },
  {
    name: "November",
    Revenue: 0,
  },
  {
    name: "December",
    Revenue: 0,
  },
];

const Dashboard = (props) => {
  const [graphsData, setGraphsData] = useState(userDataGraph);
  const [transactionList, settransactionList] = useState([]);

  useEffect(() => {
    // props.onGetStakeStats();
    props.onGetGraphData("?isAdmin=false");
  }, []);

  useEffect(() => {
    if (props.user) {
      props.onGetTransaction(
        `?page=1&limit=10&order=desc&orderBy=amount&isAdmin=false&parkingOwnerId=${props.user?._id}`
      );
    }
  }, [props.user]);

  useEffect(() => {
    settransactionList(props.transactions)
  }, [props.transactions])


  useEffect(() => {
    if (props.graph) {
      try {
        //orders
        const revenue = makeGraphDataFormat(props.graph, "totalRevenue");
        const newUserGraphData = graphsData.map((item) => {
          item.Revenue = revenue[item.name] ? revenue[item.name] : 0;
          return item;
        });
        setGraphsData(newUserGraphData);
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [props.graph]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs
            title="Dashboard"
            breadcrumbItem={props?.t("Dashboard")}
            breadcrumbItems={[{ title: props?.t("Dashboard") }]}
          /> */}
          <Welcomegreet />
          <Welcomecards />

          {/* <Row>
            <Col md="4">
              <Card className="mini-stats-wid">
                <CardBody>
                  <Media>
                    <Media body>
                      <p className="text-muted font-weight-medium">
                        Total Users
                      </p>
                      <h4 className="mb-0">{tokens}</h4>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Col>

            <Col md="4">
              <Card className="mini-stats-wid">
                <CardBody>
                  <Media>
                    <Media body>
                      <p className="text-muted font-weight-medium">
                        Total Payments
                      </p>
                      <h4 className="mb-0">{props?.stats?.day || 0}</h4>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Col>
          </Row> */}

          <div className="fillter_ssection mt-5">
            <Form>
              {/* <Row>
                <Col lg={6} md={12} sm={12}>
                  <div className="fillter_bar">
                    <h2 className="fillter_head">Filter By:</h2>
                    <div className="fillter_dropdown">
                      <FormGroup>
                        <Input type="select" name="select" id="exampleSelect">
                          <option>All</option>
                          <option>2</option>
                          <option>3</option>
                        </Input>
                      </FormGroup>
                    </div>
                    <div className="seacrch_ingput">
                      <FormGroup className="position-relative">
                        <Input
                          type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder="Search by Name"
                        />
                        <div className="search_icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                          >
                            <path
                              d="M7.1875 13.125C10.4667 13.125 13.125 10.4667 13.125 7.1875C13.125 3.90831 10.4667 1.25 7.1875 1.25C3.90831 1.25 1.25 3.90831 1.25 7.1875C1.25 10.4667 3.90831 13.125 7.1875 13.125Z"
                              stroke="#9DA3BB"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.75 13.75L12.5 12.5"
                              stroke="#9DA3BB"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                </Col>
              </Row> */}

              <div className="revenue_graph_main mt-4">
                <Row>
                  <Col lg={8} md={6} sm={12}>
                    <div className="revenue_graph">
                      {/* <img src={Revenurgraph} alt="" className="img-fluid" /> */}
                      <GraphWidget
                        title="Revenue"
                        data={graphsData}
                        dataKey="Revenue"
                        color={"#0774e8"}
                        loading={false}
                      />
                    </div>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <div className="recent_trasaction">
                      <h4>Recent Transactions</h4>
                      <ul className="trsaction_list">
                        {transactionList.map((data, index) => {
                          return (
                            <li>
                              <div className="trasaction_list">
                                <div className="trasaction_wrap">
                                  {/*imgforblue imgforyellow */}
                                  <div className="imgforblack">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="28"
                                      height="28"
                                      viewBox="0 0 28 28"
                                      fill="none"
                                    >
                                      <g clip-path="url(#clip0_102_970)">
                                        <path
                                          d="M13.8233 3.14375C10.5621 3.09594 6.032 3.16582 5.0994 5.67123L2.80783 11.0485C2.70605 10.9324 2.57284 10.8483 2.42428 10.8063L1.50167 10.5468C1.40022 10.518 1.29409 10.5095 1.18937 10.5218C1.08464 10.5342 0.983384 10.5671 0.891409 10.6187C0.799434 10.6702 0.718552 10.7395 0.653408 10.8224C0.588263 10.9053 0.540138 11.0003 0.511796 11.1019L0.0305228 12.811C0.00173819 12.9125 -0.0067196 13.0186 0.00563576 13.1234C0.0179911 13.2281 0.050916 13.3294 0.102519 13.4213C0.154123 13.5133 0.223388 13.5942 0.306337 13.6593C0.389287 13.7245 0.484286 13.7726 0.58588 13.8009L1.50876 14.0604C1.53976 14.0691 1.57023 14.072 1.60123 14.0767C1.42496 14.5162 1.31488 14.9996 1.31488 15.2873V21.5367C1.31488 21.8572 1.44886 22.0054 1.6627 22.075V23.74C1.66243 23.8878 1.69133 24.0341 1.74775 24.1707C1.80418 24.3073 1.88701 24.4313 1.9915 24.5358C2.09599 24.6403 2.22008 24.7231 2.35665 24.7795C2.49323 24.8359 2.63959 24.8647 2.78734 24.8644H5.80503C5.95276 24.8647 6.09909 24.8358 6.23563 24.7794C6.37217 24.723 6.49623 24.6402 6.6007 24.5357C6.70516 24.4312 6.78797 24.3072 6.84438 24.1706C6.90078 24.0341 6.92968 23.8878 6.9294 23.74V22.136H21.0708V23.74C21.0705 23.8878 21.0995 24.0342 21.1559 24.1707C21.2124 24.3073 21.2952 24.4314 21.3997 24.5358C21.5043 24.6403 21.6284 24.7231 21.7649 24.7795C21.9015 24.8359 22.0479 24.8647 22.1957 24.8644H25.2128C25.3606 24.8648 25.507 24.8359 25.6436 24.7795C25.7803 24.7232 25.9044 24.6404 26.0089 24.5359C26.1135 24.4314 26.1964 24.3074 26.2528 24.1708C26.3093 24.0342 26.3382 23.8878 26.338 23.74V22.075C26.5516 22.0054 26.6853 21.857 26.6853 21.5365V15.2875C26.6853 14.9999 26.5752 14.5165 26.3989 14.077C26.4299 14.0723 26.4604 14.0691 26.4914 14.0607L27.4146 13.8011C27.5161 13.7728 27.6111 13.7247 27.694 13.6595C27.7769 13.5944 27.8462 13.5135 27.8978 13.4215C27.9493 13.3296 27.9822 13.2283 27.9946 13.1236C28.0069 13.0188 27.9984 12.9127 27.9697 12.8113L27.4889 11.1021C27.4605 11.0005 27.4123 10.9055 27.3471 10.8226C27.2819 10.7397 27.201 10.6705 27.109 10.6189C27.017 10.5673 26.9157 10.5344 26.8109 10.5221C26.7062 10.5098 26.6 10.5182 26.4985 10.547L25.5759 10.8066C25.4273 10.8486 25.2941 10.9327 25.1923 11.0488L22.9008 5.67149C21.9012 3.12825 17.0845 3.19209 13.8233 3.14428V3.14375ZM23.1635 11.3882C23.2176 11.5495 23.0552 11.6567 22.8853 11.6667C22.8853 11.6667 22.3297 11.714 21.5636 11.7757C20.9807 10.4136 19.6259 9.45391 18.0565 9.45391C16.3345 9.45391 14.8723 10.6103 14.4033 12.185C14.2733 12.1868 14.1222 12.1921 14.0014 12.1921C11.0347 12.1921 5.1149 11.6667 5.1149 11.6667C4.94493 11.6567 4.78258 11.5495 4.8367 11.3882C7.11671 4.43836 7.18449 4.96062 13.8737 5.03365C20.5632 5.10668 20.6021 4.61017 23.1635 11.3882ZM18.0565 10.7674C18.4695 10.766 18.8765 10.8674 19.2405 11.0625C19.6046 11.2576 19.9143 11.5402 20.1419 11.885C18.8021 11.9843 17.26 12.0859 15.823 12.1451C16.0297 11.73 16.3485 11.381 16.7432 11.1375C17.1379 10.8941 17.5928 10.7659 18.0565 10.7674ZM2.63419 13.023C2.65441 13.0527 2.67412 13.0826 2.69645 13.1118H2.60975L2.63419 13.023ZM4.11663 14.7684C4.70351 14.7587 7.85412 15.8192 7.85412 15.8192C8.24739 15.9298 8.5939 16.6738 8.59179 17.0826C8.58602 18.4592 5.0332 17.9816 3.59122 17.9871C3.49426 17.9873 3.39822 17.9684 3.3086 17.9314C3.21897 17.8944 3.13754 17.8401 3.06897 17.7716C3.0004 17.703 2.94605 17.6216 2.90903 17.532C2.87202 17.4424 2.85307 17.3464 2.85328 17.2494V15.5064C2.85328 15.0976 3.52974 14.7781 4.11663 14.7684ZM23.8841 14.7684C24.471 14.7781 25.1474 15.0976 25.1474 15.5064V17.2494C25.1476 17.3464 25.1287 17.4424 25.0917 17.532C25.0547 17.6216 25.0003 17.703 24.9317 17.7716C24.8632 17.8401 24.7817 17.8944 24.6921 17.9314C24.6025 17.9684 24.5064 17.9873 24.4095 17.9871C22.9672 17.9816 19.4147 18.4592 19.4089 17.0826C19.4068 16.6738 19.7531 15.9298 20.1466 15.8192C20.1466 15.8192 23.2972 14.7587 23.8841 14.7684Z"
                                          fill="black"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_102_970">
                                          <rect
                                            width="28"
                                            height="28"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>

                                  <div className="trsaction_content">
                                    <h5>{data.transactionId?.slice(0, 10)}</h5>
                                    {/* <p>30 Min Duration</p> */}
                                  </div>
                                </div>

                                <h5 className="trasaction_price">{data.currencySymbol + data.amount}</h5>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="latest_cust_table mt-4">
                <LatestCustomers />
              </div>
            </Form>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {};

const mapStateToProps = ({ Settings, Stake, Dashboard, Login }) => ({
  settings: Settings?.settings,
  stats: Stake?.stats,
  graph: Dashboard.graphData,
  transactions: Dashboard.transactions,

  user: Login.user,
});

const mapDispatchToProps = (dispatch) => ({
  // onGetStakeStats: (data) => dispatch(getStakeStats(data)),
  onGetGraphData: (data) => dispatch(getGraphDataRequest(data)),
  onGetTransaction: (data) => dispatch(getTransactionRequest(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Dashboard))
);
